import { render, staticRenderFns } from "./ValidateInput.vue?vue&type=template&id=2836b78e&"
import script from "./ValidateInput.vue?vue&type=script&lang=js&"
export * from "./ValidateInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports